import { Component, OnDestroy, OnInit } from '@angular/core';
import { filter, map, startWith } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { checkRouterChildsData } from '../../@fury/utils/check-router-childs-data';
import { environment } from '../../environments/environment';
import { ApiService } from '../services/base/api.service';
import { Observable } from 'rxjs';
import { PublicNotification } from '../interfaces/configuration/public-notification';
import { PublicNotificationsService } from '../services/configuration/public-notifications.service';

@Component({
  selector: 'fury-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy {

  scrollDisabled$: Observable<any> = this.router.events.pipe(
    filter<NavigationEnd>((event: NavigationEnd): boolean => event instanceof NavigationEnd),
    startWith(null),
    map(() => checkRouterChildsData(this.router.routerState.root.snapshot, data => data.scrollDisabled))
  );

  public badConnection: boolean = false;
  public isStaging: boolean = false;

  public publicNotification: PublicNotification = null;

  constructor(private router: Router,
              private publicNotificationsService: PublicNotificationsService,
              public api: ApiService,
  ) {
  }

  ngOnInit(): void {
    this.publicNotificationsService.all().subscribe((data: PublicNotification): void => {
      if (data) {
        this.publicNotification = data;
      }
    });

    if (environment.appVersionAddon === '-staging') {
      this.isStaging = true;
    }
  }

  ngOnDestroy(): void {
  }
}

